import { validatedNo, validatedNo_internal, validateEMail, validatePhone, validateNum } from "@/utils/validate";

export default {
    //内招
    //内招是否有工号
    x_haspernr: [{ required: true, message: "请输入相应的内容" }],
    //自助平台工号（内招）
    x_zsapid: [{ required: true, message: "请输入相应的内容" }],
    //自助平台密码（内招
    x_pwd: [{ required: true, message: "请输入相应的内容" }],
    //内招，查询用身份证号
    x_queryicnum: [{ required: true, message: "请输入相应的内容" }],
    //上级领导姓名
    zsjxm: [{ required: true, message: "请输入相应的内容" }],
    //领导职务
    zzw: [{ required: true, message: "请输入相应的内容" }],
    //领导联系方式
    zlxdh: [{ required: true, message: "请输入相应的内容" },
    { validator: validatePhone, trigger: 'blur' }],

    //--------------------

    //姓名
    nachn: [
        { required: true, message: "请输入相应的内容" },
        { max: 40, message: "不能超过40个字符" }
    ],
    //电子邮件
    x_email: [
        { required: true, message: "请输入相应的内容" },
        { max: 30, message: "不能超过30个字符" },
        { validator: validateEMail, trigger: 'blur' }
    ],
    //性别
    gesch: [{ required: true, message: "请输入相应的内容" }],
    //手机号码
    x_mobile: [
        { required: true, message: "请输入相应的内容" },
        { max: 30, message: "不能超过30个字符" },
        { validator: validatePhone, trigger: 'blur' }
    ],
    //出生日期
    gbdat: [{ required: true, message: "请输入相应的内容" }],
    //政治面貌
    pcode: [{ required: true, message: "请输入相应的内容" }],

    //身份证号
    icnum: [
        { required: true, message: "请输入相应的内容" },
        { max: 30, message: "不能超过30个字符" },
        { validator: validatedNo, trigger: 'blur' }
    ],
    //内招专用-无工号-身份证号
    icnum_internal: [
        { required: true, message: "请输入相应的内容" },
        { max: 30, message: "不能超过30个字符" },
        { validator: validatedNo_internal, trigger: 'blur' }
    ],
    //内招专用-有工号-身份证号
    icnum_internal_haspernr: [
        { required: true, message: "请输入相应的内容" },
        { max: 30, message: "不能超过30个字符" }
    ],
    //民族
    zzmzu: [{ required: true, message: "请输入相应的内容" }],
    //籍贯
    x_jiguan: [{ required: true, message: "请输入相应的内容" }],
    //健康状况
    zjkzk: [{ required: true, message: "请输入相应的内容" }],
    //健康说明
    zzbzh: [{ required: true, message: "请输入相应的内容" }],
    //户口性质
    zzhkl: [{ required: true, message: "请输入相应的内容" }],
    //户口所在地
    x_fkszd: [{ required: true, message: "请输入相应的内容" }],
    //常住地址
    x_changzhu: [{ required: true, message: "请输入相应的内容" }],

    //婚姻状况
    famst: [{ required: true, message: "请输入相应的内容" }],
    //身高
    zzsg: [{ required: true, message: "请输入相应的内容" },
      // { type: 'number', message: '身高必须为数字值' },
      { validator: validateNum, trigger: 'blur' },

    ],
    //体重
    zztz: [{ required: true, message: "请输入相应的内容" },
      // { type: 'number', message: '体重必须为数字值' },
      { validator: validateNum, trigger: 'blur' },

    ],

    //--校招
    //年级排名
    znjpm: [{ required: true, message: "请输入相应的内容" }],
    //意向笔试/面试地点
    zmsd: [{ required: true, message: "请输入相应的内容" }],


    //是否有亲属在五粮液
    // zhr_zzszg: [{ required: true, message: "请输入相应的内容" }],
    x_zzszg: [{ required: true, message: "请输入相应的内容" }],
    //关系
    zhr_dptyp: [{ required: true, message: "请输入相应的内容" }],
    //亲属姓名
    zhr_dpnam: [{ required: true, message: "请输入相应的内容" }],
    //工作单位
    zhr_zzwdw: [{ required: true, message: "请输入相应的内容" }],

    //是否符从岗位调剂
    x_zfctj: [{ required: true, message: "请输入相应的内容" }],
    //--------------紧急联系人---------------

    //紧急联系人姓名
    zhr_jjlxrxm: [{ required: true, message: "请输入相应的内容" }],
    //与本人关系
    zhr_jjybrgx: [{ required: true, message: "请输入相应的内容" }],
    //紧急联系方式
    zhr_jjlxrdh: [
        { required: true, message: "请输入相应的内容" },
        { validator: validatePhone, trigger: 'blur' }
    ],
    x_internal_attafile: [{ required: true, message: "请上传附件",trigger:'change'},],
    //---------------社会关系-----------------

    "p9116.zhr_dpnam": [{ required: true, message: "请输入相应的内容" }],
    "p9116.zhr_dptyp": [{ required: true, message: "请输入相应的内容" }],
    "p9116.zhr_gbdat":  [{ required: true, message: "请输入相应的内容" }],
    "p9116.zhr_zzwdw": [{ required: true, message: "请输入相应的内容" }],
    "p9116.zhr_zzwzw": [{ required: true, message: "请输入相应的内容" }],
    "p9116.zhr_zzszg": [
        { required: true, message: "请输入相应的内容" },
        // { validator: validateZhr_zzszg, trigger: 'change' }
    ],
    'p9116.zhr_zbmcj': [{ required: true, message: "请输入相应的内容" }],
    //---------------教育经历-----------------
    //学历
    "p9100.zhr_xl": [{ required: true, message: "请输入相应的内容" }],
    //毕业院校
    "p9100.zhr_yxmc": [{ required: true, message: "请输入相应的内容" }],

    //入学时间
    "p9100.zhr_rxrq": [{ required: true, message: "请输入相应的内容" }],
    //毕业时间
    "p9100.zhr_byrq": [{ required: true, message: "请输入相应的内容" }],
    //学习形式
    "p9100.zhr_xxxs": [{ required: true, message: "请输入相应的内容" }],
    //学制
    "p9100.zhr_xz": [{ required: true, message: "请输入相应的内容" }],

    //专业:
    "p9100.zhr_zy": [{ required: true, message: "请输入相应的内容" }],
    //专业代码
    'p9100.zhr_zydm': [{ required: true, message: "请输入相应的内容" }],
    //研究方向
    'p9100.zhr_yjfx': [{ required: true, message: "请输入相应的内容" }],
    //学位
    "p9100.zhr_xwdj": [{ required: true, message: "请输入相应的内容" }],
    //QS排名
    'p9100.zhr_qspm': [{ required: true, message: "请输入相应的内容" },
                       { type: 'number', message: "请输入数字" }],

    //信息来源
    zxxly: [{ required: true, message: "请输入相应的内容" }],
    //是否可以参加入职前实习
    x_cjrzqsx: [{ required: true, message: "请输入相应的内容" }],
    //期望实习开始日期
    zhrsxrq: [{ required: true, message: "请输入相应的内容" }],
    //期望实习结束日期
    zhrrzrq: [{ required: true, message: "请输入相应的内容" }],

    //---------------实习经历-----------------
    //开始时间
    "p9101.begda": [{ required: true, message: "请输入相应的内容" }],
    //结束时间
    "p9101.endda": [{ required: true, message: "请输入相应的内容；如还没结束，请填写9999-12-31" }],
    'p9101.zhr_gzxz': [{ required: true, message: "请输入相应的内容" }],
    //单位名称
    "p9101.zhr_gzdw1": [{ required: true, message: "请输入相应的内容" }],
    //岗位名称
    "p9101.zhr_zwgw1": [{ required: true, message: "请输入相应的内容" }],
    //单位联系人
    "p9101.zhr_lxr": [{ required: true, message: "请输入相应的内容" }],
    //电话
    "p9101.zhr_dh": [{ required: true, message: "请输入相应的内容" }],
    //年收入
    "p9101.zhr_nsr": [
        { required: true, message: "请输入相应的内容" }
    ],
    //岗位职责及业绩描述
    "p9101.zhr_cszy1": [{ required: true, message: "请输入相应的内容" }],

    //---------------科研经历-----------------
  //开始时间
  "p9408.begda": [{ required: true, message: "请输入相应的内容" }],
  //结束时间
  "p9408.endda": [{ required: true, message: "请输入相应的内容" }],
  'p9408.zhr_xmmc': [{ required: true, message: "请输入相应的内容" }],
  //单位名称
  "p9408.zhr_cdjs": [{ required: true, message: "请输入相应的内容" }],
  //岗位名称
  "p9408.zhr_kyjlms": [{ required: true, message: "请输入相应的内容" }],

    //---------------是否复转军人-----------------
    x_isfzjr: [{ required: true, message: "请输入相应的内容" }],

    //服役时间开始
    zhr_rwrq: [{ required: true, message: "请输入相应的内容" }],
    //服役时间截止
    zhr_fuzrq: [{ required: true, message: "请输入相应的内容" }],
    //部队名称
    zhr_szbd: [{ required: true, message: "请输入相应的内容" }],

    //---------------语言能力-----------------
    //外语语种
    "p9103.zhr_wyyz": [{ required: true, message: "请输入相应的内容" }],
    //熟练程度
    "p9103.zhr_slcd": [{ required: true, message: "请输入相应的内容" }],
    //外语等级
    "p9103.zhr_wyjb": [{ required: true, message: "请输入相应的内容" }],
    //外语水平
    "p9103.zhr_wysp": [{ required: true, message: "请输入相应的内容" }],


    //---------------专业技术资格-----------------
    "p9109_zy.zhr_zcxl": [{ required: true, message: "请输入相应的内容" }],
    //获取资格日期
    "p9109_zy.zhr_zghqsj": [{ required: true, message: "请输入相应的内容" }],
    //资格名称
    "p9109_zy.zhr_zgmc": [{ required: true, message: "请输入相应的内容" }],
    //专业技术资格等级
    "p9109_zy.zhr_zgdj": [{ required: true, message: "请输入相应的内容" }],
    // //资格获取途径
    // "p9109_zy.zhr_qdtj": [{ required: true, message: "请输入相应的内容" }],
    //批准机构
    "p9109_zy.zhr_pzjg": [{ required: true, message: "请输入相应的内容" }],

    //---------------职业技术资格-----------------

    "p9109_job.zhr_zzymc": [{ required: true, message: "请输入相应的内容" }],
    "p9109_job.zhr_jndj": [{ required: true, message: "请输入相应的内容" }],

    //获取资格日期
    "p9109_job.zhr_zghqsj": [{ required: true, message: "请输入相应的内容" }],
    // //资格名称
    // "p9109_job.zhr_zgmc": [{ required: true, message: "请输入相应的内容" }],
    // //专业技术资格等级
    // "p9109_job.zhr_zgdj": [{ required: true, message: "请输入相应的内容" }],
    // //资格获取途径
    // "p9109_job.zhr_qdtj": [{ required: true, message: "请输入相应的内容" }],
    //批准机构
    "p9109_job.zhr_pzjg": [{ required: true, message: "请输入相应的内容" }],


  //---------------其他技术资格-----------------

  "p9109_qt.zhr_qzgmc": [{ required: true, message: "请输入相应的内容" }],
  "p9109_qt.zhr_qzgjb": [{ required: true, message: "请输入相应的内容" }],
  //获取资格日期
  "p9109_qt.zhr_zghqsj": [{ required: true, message: "请输入相应的内容" }],
  "p9109_qt.zhr_pzjg": [{ required: true, message: "请输入相应的内容" }],
}



// WEBPACK FOOTER //
// ./src/utils/rules.js